import { Helmet } from 'react-helmet';
import './acas-main.css';
import ScrollToTop from '../../../../../components/scrollToTop/scrollToTop';
import { useState } from 'react';
import AcasInfo from './acas-info';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import Swal from 'sweetalert2';

function Acas() {
  const [showView, setShowView] = useState("principalView");
  const [awbInfo, setAwbInfo] = useState({})
  const [existAcas, setExistAcas] = useState({});
  const { 
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();

  const handleValidateMaster = async (data) => {
    try {
      const url = `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/acas`;
      const body = { awb: data.inputMaster }

      const response = await axios.post(url, body);

      setAwbInfo(response.data.body.awbData);
      setExistAcas(response.data.body.existAcas);

      if(response.data.status === 200) {
        setShowView("secondaryView");
      }

    } catch (error) {
      console.error(error.response.data.body);
      Swal.fire("Error", error.response.data.body, "error");
    }
  }

  const updateAcasInfo = async (idMaster) => {
    try {
      const url = `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/acas/verifyAcas?idMaster=${idMaster}`;
      const response = await axios.get(url);
      setExistAcas(response.data.body);
    } catch (error) {
      console.error(error.response.data.body);
      Swal.fire("Error", "Error, por favor intenta mas tarde", "error");
    }
  }
  
  return (
    <>
      <Helmet>
        <title>Horus | Aceptación</title>
      </Helmet>
      <ScrollToTop />
      
      <div className="container-fluid">
        {showView === "principalView" && (
          <div className="row justify-content-center">
            <form className="col-6" onSubmit={handleSubmit(handleValidateMaster)}>
              <label htmlFor="inputMaster" className="amc-label">
                Master
              </label>
              <input
                type="text"
                className="form-control"
                id="inputMaster"
                {...register("inputMaster", {
                  required: "Este campo es requerido",
                  pattern: {
                    value: /^\d{3}-\d{8}$/,
                    message: "Formato invalido"
                  }
                })}
              />
              {errors.inputMaster && <small className="text-danger">{errors.inputMaster.message}</small>}
              <div className="btns mt-3 d-flex justify-content-end gap-3">
                <button className="btnn" type='submit'>
                  Buscar
                </button>
              </div>
            </form>
          </div>
        )}

        {showView === 'secondaryView' && (
          <AcasInfo awbInfo={ awbInfo } existAcas={ existAcas } updateAcasInfo={ updateAcasInfo } />
        )}
      </div>
    </>
  )
}

export default Acas;